import { createSlice } from '@reduxjs/toolkit';

export const user = createSlice({
  name: 'user',
  initialState: {
    isAuth: false,
    orgId: null,
    token: {
      access: '',
      refresh: '',
    },
    userInfo: {},
    selectedTemplateId: 0,
    selectedTimeRange: null,
  },
  reducers: {
    setuserInfo: (state, action) => {
      state.userInfo = action.payload;
    },
    setAuth: (state, action) => {
      state.isAuth = action.payload;
    },
    setOrgId: (state, action) => {
      state.orgId = action.payload;
    },
    setToken: (state, action) => {
      state.token = action.payload;
    },
    setSelectedTemplateId: (state, action) => {
      state.selectedTemplateId = action.payload;
    },
    setSelectedTimeRange: (state, action) => {
      state.selectedTimeRange = action.payload;
    },
    resetUser: (state) => {
      state.isAuth = false;
      state.token = {
        access: '',
        refresh: '',
      };
      state.userInfo = {};
      state.selectedTemplateId = 0;
      state.selectedTimeRange = null;
    },
  },
});

export const { setAuth, setToken, setuserInfo, resetUser, setSelectedTemplateId, setSelectedTimeRange, setOrgId } =
  user.actions;

export default user.reducer;
